import React, { memo } from 'react';

import style from './AccordionCell.scss';

export const AccordionCell = memo(({ className = '', content }) => (
    <div className={`${className} ${style.cell}`}>{content}</div>
));
